/**
 * `config.js`
 *  -  設定ファイル
 *
 * 使用方法:
 *  - import { config } from "../config.js";
 */

export const config = {
  mode: 'production',           // production or development
  domainProd: 'recruit.nipponrika.jp',  // 本番環境のドメイン
  useBarba: true,               // Barba.js を使うかどうか
  momentumScrolling: "lenis",   // "gsap" | "lenis" | "none"  (gsapはgsapScrollSmoother）
  useGsap: true,                // GSAP を使うかどうか
  useGsapScrollTrigger: true,   // GsapScrollTrigger を使うかどうか
  useThreeJS: false,            // Three.js を使うかどうか
  useSwiper: true,              // Swiper を使うかどうか（スライダー）
  useFlatpickr: false,          // Flatpickr を使うかどうか（日付選択モーダル）
  gaTagType: 'ga4',             // ga4 || gtm  GTMを使う場合は、GTM側のSPA設定を有効にするだけでOK。gaTagTypeをgtmにすることでJS側でのイベント送信を無効化できる。
  gaTagId:   'G-MPXKTZDVM1',    // プロジェクトのGTM, GA4アカウント
  recaptchaPublicKey: '',       // reCAPTCHAの公開鍵（PHP側に秘密鍵もあるので変更等注意）// Recaptchaの使用 https://www.google.com/recaptcha/admin/
};

